module.exports = __webpack_public_path__ + "static/media/ajua.d77dd522.png";